import React, { useEffect } from 'react';
import { C as Colors } from './Colors-n4us094c.js';

const ColorField = ({ option, control, errors, onColorChange, onOptionsChange, pageReady, setValue, }) => {
    useEffect(() => {
        if (typeof onOptionsChange === 'function')
            onOptionsChange(option.option.attribute_code);
    }, [option.option.values.length]);
    return (React.createElement("div", { className: "col-left colors" },
        React.createElement("div", { className: "product-colors" },
            React.createElement(Colors, { option: option.option, disabled: option.disabled, control: control, errors: errors, onColorChange: onColorChange, pageReady: pageReady, setValue: setValue }))));
};

export { ColorField as C };
//# sourceMappingURL=ColorField-jh1w3ok7.js.map
